import { render, staticRenderFns } from "./SectionComplaint.vue?vue&type=template&id=21e1861c&scoped=true&"
import script from "./SectionComplaint.vue?vue&type=script&lang=js&"
export * from "./SectionComplaint.vue?vue&type=script&lang=js&"
import style0 from "./SectionComplaint.vue?vue&type=style&index=0&id=21e1861c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1861c",
  null
  
)

export default component.exports